export type AlignTo = "auto-cursor" | "auto-target";
